import React from 'react'

const AdvertiseInfoWidget = (props) => {
  return <div>Advertise Info Here</div>
}

AdvertiseInfoWidget.propTypes = {}

export default AdvertiseInfoWidget
